import { useState } from "react";
import { ALPHA__Drawer as Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import { getPromoMessaging } from "../../utils/product/getPromoMessaging";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import { ListItem } from "./../__shared__/ListItem/ListItem";
import Info24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Info24PxOutlined";
import styles from "./FeatureMessagesDrawer.module.scss";
import FeatureMessagesDrawerFeature from "./components/FeatureMessagesDrawerFeature/FeatureMessagesDrawerFeature";
import { dispatchMonetateQEvent } from "../../utils/monetate/monetateQ";

type Props = {
  /**
   * An array of Message objects.
   */
  messages: (NonPromotionalMessage | PromotionalMessage)[];
};

export const FeatureMessagesDrawerUI = ({ messages }: Props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const { featureDrawerMessages } = getPromoMessaging(messages, true);

  if (featureDrawerMessages.length === 0) {
    return null;
  }

  const labelText = (
    <div className={styles.featureMessagesListItemLabel}>
      <span>{featureDrawerMessages[0]?.title}</span>
      {featureDrawerMessages.length > 1 ? (
        <span className={styles.featureMessagesNumber}>{`+${
          featureDrawerMessages.length - 1
        }`}</span>
      ) : null}
    </div>
  );

  return (
    <>
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={() => {
          dispatchMonetateQEvent("FEATURES_DRAWER_OPEN");
          setDrawerIsOpen(true);
        }}
        label={labelText}
        leadingIcon={<Info24PxOutlined />}
        data-testid="feature-messages-drawer-header"
        className={styles.featureMessagesListItem}
      />
      <Drawer
        isOpen={drawerIsOpen}
        onClose={() => {
          setDrawerIsOpen(false);
        }}
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        rootId="page-root"
        isOffersDrawer
        contentClassName={styles.featureDrawer}
        headerStyleModifier={styles.featureDrawerHeader}
      >
        {featureDrawerMessages.map((feature, index) => (
          <FeatureMessagesDrawerFeature key={index} feature={feature} />
        ))}
      </Drawer>
    </>
  );
};
